<template>
  <div class="ybl-main" id="yblMain">
    <div class="content">
      <div class="scroll-box">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'yblMain',
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    // this.getContentHeight()
    // window.onresize = () => {
    //   this.getContentHeight()
    // }
  },
  methods: {
    getContentHeight (newVal) {
      let height = document.documentElement.clientHeight
      let bottomH = 70 // 距离页面下方高度
      let headH = 60 // 头部高度 60
      let titleH = (document.getElementById('yblPageHead') && document.getElementById('yblPageHead').offsetHeight) || 0 // 标题
      this.tableHeight = height - bottomH - headH - titleH
      document.getElementById('yblMain').style['min-height'] = `${this.tableHeight}px`
      console.log(titleH)
    }
  }
}
</script>
<style lang="less" scoped>
.ybl-main {
  width: 100%;
  height: 100%;
  margin: 14px 0 0 0;
  display: flex;
  flex: 1;
  background-color: #fff;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;
  .content {
    // display: flex;
    // flex-direction: column;
    width: 100%;
    height: 100%;
    position: absolute;
    // overflow-y: auto;
    overflow: hidden;
    // bottom: 10px;
  }
  .scroll-box {
    width: 100%;
    height: 100%;
    // position: absolute;
    overflow-y: auto;
    // margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue